import React from 'react';
import { styled, IconButton } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

export const MoreInsuranceInfo = styled('div')({
  cursor: 'default',
  display: 'flex',
  flexDirection: 'column',
  marginTop: '25px',
  color: '#090909'
});

export const ExpandMoreButtonWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  '& > p': {
    color: '#090909',
    cursor: 'pointer'
  },
  '& svg': {
    color: '#090909'
  }
});

export const ExpandMoreButton = styled((props: any) => {
  const { expanded, ...other } = props;

  return (
    <IconButton {...other}>
      <ExpandMore />
    </IconButton>
  )
})(({ theme, expanded }) => ({
  transform: !expanded ? 'rotate(0deg)' : 'rotate(180deg)',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  })
}));

export const InsuranceInfoList = styled((props: any) => {
  const { expanded, ...other } = props;
  return (<ul {...other}></ul>)
})(({ theme, expanded }) => ({
  listStyle: 'none',
  color: '#090909',
  marginTop: '0px',
  overflow: 'hidden',
  height: expanded ? '120px' : '0px',
  transition: theme.transitions.create('height', {
    duration: theme.transitions.duration.shortest,
  })
}));

export const InsuranceInfoListItem = styled((props: any) => {
  const { name, value, ...other } = props;
  return (<li {...other}><b>{name}:</b> {value}</li>)
})(() => ({
  cursor: 'default',
  fontSize: '14px',
  marginTop: '10px'
}));